export default "__VITE_ASSET__B60to9Fb__"